import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { LuckyOrangeProvider } from './context/LuckyOrangeProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/*
     * LuckyOrangeProvider wraps the entire application so that
     * useLuckyOrange() is available on every page — public forms,
     * HR dashboards, and the employee packet flow.
     *
     * The `siteId` is read from REACT_APP_LUCKY_ORANGE_SITE_ID.
     * If the variable is not set the script is silently skipped,
     * which means local dev sessions are never tracked.
     */}
    <LuckyOrangeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </LuckyOrangeProvider>
  </React.StrictMode>
);

reportWebVitals();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
